import React, { useState } from 'react';
import { setContract } from '../../utils/api';

const SmartContract = ({ config, loadConfig, flash }) => {
  const [addr, setAddr] = useState(config.tokenContractAddress || '');
  const [chain, setChain] = useState(String(config.tokenContractChainId || 56));
  const f = (n, d = 4) => (n == null) ? '0' : parseFloat(n).toFixed(d);

  return (
    <div className="fade-in">
      <h2 className="adm-title">Smart Contract</h2>
      <div className="adm-kpi-grid cols-3">
        <div className="adm-kpi card"><span className="adm-kpi-label">Status</span><strong className="adm-kpi-val mono">{config.isContractDeployed ? '✓ Deployed' : '✗ Not deployed'}</strong></div>
        <div className="adm-kpi card"><span className="adm-kpi-label">Address</span><strong className="adm-kpi-val mono adm-break">{config.tokenContractAddress || '—'}</strong></div>
        <div className="adm-kpi card"><span className="adm-kpi-label">Chain</span><strong className="adm-kpi-val mono">{config.tokenContractChainId || '—'}</strong></div>
      </div>
      <div className="card adm-sub">
        <h3>{config.isContractDeployed ? 'Update' : 'Set'} Contract</h3>
        <div className="adm-form-grid cols-3">
          <div className="adm-field"><label>Address</label><input placeholder="0x..." value={addr} onChange={e=>setAddr(e.target.value)} className="input"/></div>
          <div className="adm-field"><label>Chain ID</label><input type="number" value={chain} onChange={e=>setChain(e.target.value)} className="input"/></div>
          <div className="adm-field adm-field-end adm-field-actions">
            <button className="btn btn-primary" onClick={async()=>{if(!addr){flash('Required','error');return;}try{const r=await setContract({contractAddress:addr,chainId:parseInt(chain)});flash(r.message);loadConfig();}catch(e){flash(e.response?.data?.error||'Failed','error');}}}>Save</button>
            {config.isContractDeployed && <button className="btn btn-outline danger" onClick={async()=>{if(!window.confirm('Remove?'))return;try{await setContract({contractAddress:'',chainId:0,remove:true});flash('Removed');loadConfig();}catch(e){flash(e.response?.data?.error||'Failed','error');}}}>Remove</button>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SmartContract;